import React, { useCallback } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function LoadingJobPostComponent() {
  return (
    <div className="single-post d-flex flex-row">
      <div className="thumb pr-30">
        <Skeleton count={1} width={120} height={40} />
      </div>
      <div className="details flex-grow">
        <div className="title d-flex flex-row justify-content-between">
          <div className="titles flex-grow">
            <h4>
              <Skeleton count={1} width={"90%"} />
            </h4>
            <h6>
              <Skeleton count={1} width={"20%"} />
            </h6>
          </div>
          <ul className="list-inline pull-right">
            <li className="list-inline-item">
              <Skeleton count={1} width={76} height={47} />
            </li>
            <li className="list-inline-item">
              <Skeleton count={1} width={76} height={47} />
            </li>
          </ul>
        </div>
        <h5>
          <Skeleton count={1} width={"50%"} />
        </h5>
        <p className="address">
          <Skeleton count={1} width={"30%"} />
        </p>
      </div>
    </div>

    //  <SkeletonTheme baseColor="#ccc" highlightColor="#f2f2f2">
    //    <p>
    //      <Skeleton count={3} />
    //    </p>
    //  </SkeletonTheme>
  );
}
